module.exports = __webpack_public_path__ + "img/Icon-checkup-edit.80ef325a.svg";